
<ion-button class="ion-no-margin" style="height: 100%;" *ngIf="ballChange?.count === null" (click)="changeBallChangePolicy()" expand="block" fill="clear" color="tertiary">
    {{'Add rule for ball change' | translate}}
</ion-button>        

<ion-row *ngIf="ballChange?.count !== null" (click)="changeBallChangePolicy()">
    <ion-col size="12" class="ion-text-center">
        <span class="ball-change">{{'Ball change in' | translate}}</span>
    </ion-col>
    <ion-col size="12" class="ion-text-center">
        <ion-text [color]="color" *ngIf="ballChange?.count > -1">
            <span *ngIf="ballChange?.count === 1" class="ball-change message">{{ ballChange?.count }} {{ ballChange?.type }}</span>
            <span *ngIf="ballChange?.count > 1 || ballChange?.count === 0" class="ball-change message">{{ ballChange?.count }} {{ ballChange?.type }}s</span>
        </ion-text>

        <ion-text color="dark" *ngIf="0 > ballChange?.count">
            {{'Completed' | translate}}
        </ion-text>
    </ion-col>
</ion-row>
